import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  city: Yup.string().required('Veld is verplicht'),
  addressLine1: Yup.string().required('Veld is verplicht'),
  addressLine2: Yup.string(),
  postcode: Yup.string(),
  isPoBox: Yup.boolean().default(false),
});
